import { matchPath } from "react-router-dom";
import { routes } from "./registry";

/**
 * Maps a legacy edit-itinerary path to its canonical registry path, or `undefined` if unrecognised.
 * Shared by the browser redirect and native nav's synchronous path resolution, which needs
 * the answer before a `<Navigate>` redirect would otherwise apply it.
 */
const PARAMLESS_REDIRECTS: ReadonlyArray<readonly [from: string, to: string]> = [
  ["/edit/transport/list", routes.edit.transportList.path],
  ["/edit/activities/general", routes.edit.activitiesList.path],
  ["/edit/eventInfo/edit", routes.edit.eventInfo.path],
  ["/edit/hotelbooking/search", routes.edit.hotelSearch.path],
  ["/edit/hotelbooking/details", routes.edit.hotelDetails.path],
  ["/edit/hotelbooking/avail", routes.edit.hotelAvailability.path],
  ["/edit/hotelbooking/return", routes.edit.hotelReturn.path],
  ["/edit/publicItins", routes.edit.publicItineraries.path],
];

export const LEGACY_EDIT_REDIRECTS = PARAMLESS_REDIRECTS;

export function resolveLegacyEditPath(path: string): string | undefined {
  for (const [from, to] of PARAMLESS_REDIRECTS) {
    if (matchPath(from, path)) return to;
  }

  const sectionItemPageItemMatch = matchPath("/edit/Section/:sectionID/:idItem/:idSubPage/:idSubItem", path);
  if (sectionItemPageItemMatch) {
    const { sectionID, idItem, idSubPage, idSubItem } = sectionItemPageItemMatch.params;
    return routes.edit.sectionItemPageItem.build({
      sectionId: sectionID!,
      itemId: idItem!,
      pageId: idSubPage!,
      subItemId: idSubItem!,
    });
  }

  const sectionItemPageMatch = matchPath("/edit/Section/:sectionID/:idItem/:idSubPage", path);
  if (sectionItemPageMatch) {
    const { sectionID, idItem, idSubPage } = sectionItemPageMatch.params;
    return routes.edit.sectionItemPage.build({ sectionId: sectionID!, itemId: idItem!, pageId: idSubPage! });
  }

  const sectionItemMatch = matchPath("/edit/Section/:sectionID/:idItem", path);
  if (sectionItemMatch) {
    const { sectionID, idItem } = sectionItemMatch.params;
    return routes.edit.sectionItem.build({ sectionId: sectionID!, itemId: idItem! });
  }

  const sectionMatch = matchPath("/edit/Section/:sectionID", path);
  if (sectionMatch) {
    return routes.edit.section.build({ sectionId: sectionMatch.params.sectionID! });
  }

  const transportMatch = matchPath("/edit/transport/list/:idItem", path);
  if (transportMatch) return routes.edit.transportItem.build({ itemId: transportMatch.params.idItem! });

  const activityMatch = matchPath("/edit/activities/general/:idItem", path);
  if (activityMatch) return routes.edit.activityItem.build({ itemId: activityMatch.params.idItem! });

  const todoMatch = matchPath("/edit/activities/todos/:idItem", path);
  if (todoMatch) return routes.edit.todoItem.build({ itemId: todoMatch.params.idItem! });

  const hotelManageMatch = matchPath("/edit/hotelbooking/manage/:idItem", path);
  if (hotelManageMatch) return routes.edit.hotelManage.build({ itemId: hotelManageMatch.params.idItem! });

  return undefined;
}
